import { addQueryArgs } from '@wordpress/url';

const realpressWishList = () => {
	const wishlistToggleNode = document.querySelector( '.realpress-property-item-tools .realpress-property-wishlist' );
	if ( ! wishlistToggleNode ) {
		return;
	}

	const propertyId = REALPRESS_SINGLE_PROPERTY_PAGE.property_id || '';
	if ( ! propertyId ) {
		return;
	}
	const data = { property_id: propertyId };
	const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';

	const isLoggedIn = document.body.classList.contains( 'logged-in' );

	wishlistToggleNode.addEventListener( 'click', function() {
		wishlistToggleNode.disabled = true;
		if ( ! isLoggedIn ) {
			const loginPageUrl = REALPRESS_GLOBAL_OBJECT.login_page_url || '';
			if ( ! loginPageUrl ) {
				return;
			}

			const redirectTo = { redirect_to: document.location.origin + document.location.pathname };
			document.location.href = addQueryArgs( loginPageUrl, redirectTo );
			return;
		}

		const wishlist = wishlistToggleNode.classList.contains( 'realpress-wishlist' );
		if ( wishlist ) {
			wishlistToggleNode.classList.remove( 'realpress-wishlist' );
		} else {
			wishlistToggleNode.classList.add( 'realpress-wishlist' );
		}

		wp.apiFetch( {
			path: '/' + restNamespace + '/user/favorite',
			method: 'POST',
			data,
		} ).then( ( res ) => {
		} ).catch( ( err ) => {
			console.log( err );
		} ).finally( () => {
			wishlistToggleNode.disabled = false;
		} );
	} );
};

export default realpressWishList;
